import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const OrderDetailPage = lazyPage(() => import("./pages/OrderDetailPage"), "OrderDetailPage");
const OrdersListPage = lazyPage(() => import("./pages/OrdersListPage"), "OrdersListPage");

export const ordersModule: WebModule = {
  id: "orders",
  nav: null,
  routes: [
    { path: "/orders", element: <OrdersListPage /> },
    { path: "/orders/:id", element: <OrderDetailPage /> },
  ],
  publicRoutes: [],
};
